import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface Notification {
  name: string;
  api_token: string;
}

export interface NotificationDetaiInfor {
  errors: unknown;
  Notification: Notification;
  isAuthenticated: boolean;
}

@Module
export default class NotificationDetail
  extends VuexModule
  implements NotificationDetaiInfor
{
  errors = {};
  Notification = {} as Notification;
  isAuthenticated = !!JwtService.getToken();

  /**
   * Get current user object
   * @returns User
   */
  get NotificationDetail() {
    return this.notificationDetailData;
  }

  /**
   * Verify user authentication
   * @returns boolean
   */

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors = { ...error };
  }

  @Mutation
  [Mutations.NOTIFICATION_DETAIL_DATA](Notification) {
    this.notificationDetailData = Notification;
  }
  @Action
  [Actions.NOTIFICATION_DETAIL](payload) {
    return ApiService.getDataDetail(
      "/notifications",
      payload,
      "detail",
      payload
    )
      .then(({ data }) => {
        this.context.commit(Mutations.NOTIFICATION_DETAIL_DATA, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
      });
  }
}
